import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ImportConfigurationEmailFormType } from './configuration-form-email-form-type';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { Component, AfterViewChecked, OnInit, ChangeDetectorRef } from '@angular/core';
import { EmailAccountDirection, EmailAccountSettingsDTO, FilterCondition, FilterDTO, FilterOperator, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { EmailSettingsService } from 'src/app/domain/settings/email-settings/email-settings.service';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';

@Component({
    selector: 'app-configuration-form-email',
    templateUrl: './configuration-form-email.component.html',
    styleUrls: ['./configuration-form-email.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, TranslateModule, DropDownListAllModule, TooltipModule]
})
export class ConfigurationFormEmailComponent implements OnInit, AfterViewChecked {

  public get configurationFormEmail(): FormGroup<ImportConfigurationEmailFormType> {
    return this.formsCoordinationService.configurationFormEmail;
  }

  public dropdownSettings = {
    text: 'accountName',
    value: 'id'
  };

  public emailSettings: EmailAccountSettingsDTO[] = [];

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
    private emailSettingsService: EmailSettingsService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.getEmailConfigurations();
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  private getEmailConfigurations() {
    this.emailSettingsService.getInEmailAccounts().subscribe(accounts => {
      this.emailSettings = accounts;

      if (this.emailSettings.length < 1){
        //Mark tab as invalid
        this.formsCoordinationService.setFormDirty();
        return;
      }

      //Set first if none is selected
      if (this.configurationFormEmail.controls.emailAccountId.value == 0 && this.emailSettings?.length > 0){
        this.configurationFormEmail.controls.emailAccountId.setValue(this.emailSettings[0].id);
      }
      this.cdr.detectChanges();
    })
  }
}
